import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DataService } from '../../data.service';
//import productListJson from './product_list_mockdata';
import {
  CdkDrag,
  CdkDragMove,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
} from '@angular/cdk/drag-drop';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { useRpcBridge } from 'src/app/core/rpc-bridge.service';

declare const $: any;

type ListingViewMode = 'tile' | 'list';
@Component({
  selector: 'app-product-manager',
  // templateUrl: './product-manager-drag-drop.component.html',
  templateUrl: './product-manager.component.html',
  styleUrls: ['./product-manager.component.scss'],
})
export class ProductManagerComponent implements OnInit {
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;

  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;

  public initialArrangement = []; // Initially loaded or unchanged arrangement
  public productArrangement = []; // Arrangement state for current listing
  public customArrangement = {}; // Arrangement from backend, multi country
  customArrangementReady = false;
  isSavingArrangement = false;

  listingView: ListingViewMode = 'list';

  updatingDisplayQueue = [];

  filteredString: string = '';
  filteredCountry: string = '';
  filteredStatus: string = '';
  filteredStatusDisplay: string = '';
  filteredSubscription: string = '';
  isFromEdit = false;

  editorImgURL: any;
  editorMediaPhoto: any;

  imgURL: any;
  media_photo: any;

  bearer;
  medias;
  products = [];
  productLength: [];
  country;

  closeResult = '';

  productNameFilter;
  countryFilters = [];
  selectedCountry;
  title;
  caption;
  alt_text;
  filesize;
  preferredOptions;

  customInfo;

  statusFilters = [
    { display: 'All', value: '' },
    { display: 'Available', value: '1' },
    { display: 'Not Available', value: '9' },
  ];

  selectedStatus = this.statusFilters[0];
  withPagination = false;
  //page = 1;
  //pageSize = 25;

  displayedProducts = [];
  expanded = [];
  page = 1;
  selectedPage = 500;
  start = 0;
  end = 0;
  loading = true;
  loadingInfo = true;

  success;

  productCustomerForm: FormGroup;
  body = [];
  store_id;
  product_id;
  language_code;
  product_name;
  product_overview;
  product_desc;
  primary_photo;
  language;
  language_name;
  is_subscription = 0;
  subscriptionProduct = false;
  subscription;
  subscription_status = ['Products', 'Subscriptions'];
  //language_code ='en_US';

  errorMsg = '';

  buildForm() {
    this.productCustomerForm = this.formBuilder.group({
      product_name: [''],
      product_overview: [''],
      product_desc: [''],
      store_id: [''],
      language_code: [''],
      product_id: [''],
      imgURL: [''],
    });
  }

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private utils: UtilitiesService,
    private viewportRuler: ViewportRuler,
    private dataService: DataService
  ) {
    this.target = null;
    this.source = null;
  }

  ngOnInit(): void {
    this.isFromEdit = this.dataService.getFromProductEdit();
    const filters = this.dataService.getProductFilters();
    if (this.isFromEdit && filters) {
      this.filteredString = filters.filteredString || '';
      this.filteredCountry = filters.filteredCountry || '';
      this.is_subscription = filters.is_subscription !== undefined ? filters.is_subscription : 0;
      this.subscription = filters.subscription || 'Products';
    } else {
      this.dataService.clearProductFilters();
    }
    this.dataService.setFromProductEdit(false);

    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    $.trumbowyg.svgPath = '/library/trumbowyg-dist/ui/icons.svg';
    setTimeout(() => {
      $('.text-textarea').trumbowyg();
    }, 10);

    //this.getFilteredStatus();
    this.fetchCountry();
    this.fetchProductArrangement();
    this.fetchProductList();
  }

  ngAfterViewChecked(changes) {
    // console.log('ngAfterViewChecked', changes);
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('ngOnChanges', { changes });
  }

  ngAfterContentChecked(changes: SimpleChanges) {
    // console.log('ngAfterContentChecked', { changes });
  }

  async filterSvoProductList(productList) {
    // const mockData = await import('../../svo_product_mock.json');
    // const svoProductList = mockData.default?.list;
    let svoProductList = null;
    try {
      const rpc = useRpcBridge(window.parent);
      svoProductList = await rpc.call('svo-product-list');
      svoProductList = svoProductList?.list;
      console.log('rpc >>>', rpc, svoProductList);
    } catch (e) {
      console.log('rpc error>>>', e);
      return productList;
    }

    // Filter productList by requiring both fields to match
    const filteredProductList = productList.filter((p) => p.svo_ai || p.is_svo_ai);
    console.log('filteredProductList', { filteredProductList });

    // Use the filtered list as needed
    return filteredProductList;
  }

  fetchProductList() {
    this.loading = true;

    this.svc.getStoreLanguage(this.bearer, this.store_id).subscribe(
      (res) => {
        const allLanguages = res['data'];

        const enabledLanguages = allLanguages.filter((lang) => +lang.status);
        const defaultLanguage =
          allLanguages.find((lang) => +lang.default) ?? allLanguages[0];

        this.language = enabledLanguages;
        let localPreferredOptions = JSON.parse(
          localStorage.getItem('preferredOptions')
        );
        if (localPreferredOptions != null) {
          this.language_code =
            localPreferredOptions.productManager_LanguageCode;
          this.language_name =
            localPreferredOptions.productManager_LanguageName;
        } else {
          this.language_code = defaultLanguage['language_code'];
          this.language_name = defaultLanguage['language_name'];
        }

        this.reloadProductList();
        this.generateArrangementList();
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  reloadProductList() {
    console.log('reloadProductList');
    this.svc
      .getProductLists(this.bearer, this.store_id, this.language_code)
      .subscribe(async (res) => {
        let productList = res['data'];
        console.log('productList1', { productList });
        productList = await this.filterSvoProductList(productList);
        console.log('productList2', { productList });
        this.products = productList;
        this.loading = false;
        // console.log('product list trace',productList)
        this.updateFilter();
        this.generateArrangementList(true);
      });
  }

  saveLastArrangementListChanged(arrangementList = []) {
    this.initialArrangement = arrangementList;
    let countryCode = this.getSelectedCountryCode;
    this.customArrangement[countryCode] = arrangementList;
  }

  saveProductArrangement(event) {
    this.isSavingArrangement = true;
    const body = {
      store_id: this.store_id,
      arrangement: this.productArrangement,
      country_code: this.getSelectedCountryCode,
    };

    this.svc.updateCustomArrangement(body, this.bearer).subscribe(
      (res) => {
        this.isSavingArrangement = false;
        this.saveLastArrangementListChanged(this.productArrangement);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  fetchProductArrangement() {
    this.svc.getProductCustomArrangement(this.bearer).subscribe(
      (res) => {
        this.customArrangement = res?.['data'];
        this.sortByArrangementList();
        this.customArrangementReady = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  generateArrangementList(doSort = false) {
    let productArrangement = Object.entries(this.displayedProducts).map(
      (product: any) => +product[1].p_id
    );
    // console.log(this.initialArrangement);
    // console.log(productArrangement);

    this.productArrangement = productArrangement;
    if (doSort) this.sortByArrangementList();
  }

  sortByArrangementList() {
    this.customArrangement;
    this.productArrangement;

    console.log('Trying to sort sortByArrangementList');

    if (this.customArrangementReady && this.productArrangement?.length) {
      // Arrangement ready
      let countryCode = this.getSelectedCountryCode;
      let newArrangement = [...(this.customArrangement[countryCode] ?? [])];
      this.productArrangement.forEach((p_id) => {
        if (!newArrangement.includes(p_id)) {
          newArrangement.push(p_id);
        }
      });
      this.productArrangement = newArrangement;

      let arrangedProducts = [];
      console.log('Sort by arrangement');
      newArrangement.forEach((p_id) => {
        let productFound = this.displayedProducts.find(
          (product) => +product.p_id === +p_id
        );

        // Only insert non-empty
        if (productFound) arrangedProducts.push(productFound);
      });

      // Replace displayedProducts with arrangedProducts
      this.displayedProducts = arrangedProducts;

      // Save/Reset unchanged arrangement list with new value
      this.saveLastArrangementListChanged(newArrangement);
    }
  }

  get isArrangementModified(): boolean {
    let { initialArrangement, productArrangement } = this;
    return initialArrangement.some((v, i) => +v !== +productArrangement[i]);
  }

  get isTileView() {
    return this.listingView === 'tile';
  }

  get isListView() {
    return this.listingView === 'list';
  }

  get getSelectedCountryCode(): string {
    return this.filteredCountry?.toUpperCase();
  }

  isHidden(displayStatus) {
    return +displayStatus === 9 ? false : true;
  }

  changeLanguage(languageCode, languageName) {
    this.loading = true;
    this.displayedProducts = this.products = null;
    this.language_code = languageCode;
    this.language_name = languageName;
    this.preferredOptions = {
      productManager_LanguageName: languageName,
      productManager_LanguageCode: languageCode,
    };
    localStorage.setItem(
      'preferredOptions',
      JSON.stringify(this.preferredOptions)
    );

    this.reloadProductList();
  }

  changeCountry(countryCode) {
    this.filteredCountry = countryCode;

    this.updateFilter();
    this.generateArrangementList(true);
  }

  changeSubscription(sub) {
    if (sub === 'Subscriptions') {
      this.is_subscription = 1;
      this.subscription = 'Subscriptions';
    } else if (sub === 'Products') {
      this.is_subscription = 0;
      this.subscription = 'Products';
    }
    this.updateFilter();
  }

  resetProductCustom(product_id) {
    this.utils.msgBox.open({
      message: this.utils.translate('Clear all changes and reset to default?'),
      title: this.utils.translate('Confirm Revert?'),
      icon: 'warning',
      buttonList: [
        {
          text: 'No',
        },
        {
          text: 'Discard',
          style: 'danger',
          onClick: () => {
            this.svc
              .resetProductCustom(this.bearer, product_id, this.language_code)
              .subscribe((res) => {
                if (res['status'] == 'success') {
                  this.changeLanguage(this.language_code, this.language_name);
                  this.utils.notify.showSuccess(
                    this.utils.translate(
                      'Product details have been reverted back to default!'
                    )
                  );
                } else {
                  this.utils.notify.showError(
                    this.utils.translate('Fail to reset!')
                  );
                }
              });
          },
        },
      ],
    });
  }

  getFilteredStatus() {
    this.filteredStatus = '1';
    this.filteredStatusDisplay = 'Available';
  }

  fetchCountry() {
    this.svc.getCountry(this.bearer).subscribe((res) => {
      res['data'].forEach((item) => {
        if (item['country_name'] == 'Malaysia-Brunei') {
          item['country_name'] = 'Brunei';
        }
      });
      let defaultCountry = res['data'].find((index) => {
        if (parseInt(index['default']) === 1) {
          return index;
        }
      });

      this.country = [{ country_code: '', country_name: 'All Countries' }];
      const filters = this.dataService.getProductFilters();
      if (this.isFromEdit && filters && filters.filteredCountry !== undefined && filters.filteredCountry !== null) {
        this.filteredCountry = filters.filteredCountry;
      } else {
        this.filteredCountry = defaultCountry['country_code'] ?? 'MY';
      }
      if (res['data']) {
        res['data'].forEach((value) => {
          value.country_name = value.country_name.split('-').pop().trim();
          this.country.push(value);
        });
      }
    });
  }

  openModal(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'modal-customer',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  successModal(success) {
    this.modalService
      .open(success, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        windowClass: 'modal-success',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          this.modalService.dismissAll();
          this.changeLanguage(this.language_code, this.language_name);
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          this.modalService.dismissAll();
          this.changeLanguage(this.language_code, this.language_name);
        }
      );
    //location.reload();
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  isUpdatingDisplay(productId) {
    return !!this.updatingDisplayQueue.includes(productId);
  }

  addUpdateDisplayQueue(productId) {
    this.updatingDisplayQueue.push(productId);
  }

  removeUpdateDisplayQueue(productId) {
    this.updatingDisplayQueue = this.updatingDisplayQueue.filter(
      (p) => +p !== +productId
    );
  }

  updateDisplayStatus(productId, displayStatus, event) {
    let body = {
      store_id: this.store_id,
      product_id: productId,
      display: +!displayStatus,
      language_code: this.language_code,
    };

    if (this.isUpdatingDisplay(productId)) return;
    this.addUpdateDisplayQueue(productId);

    this.svc.updateDisplayStatus(body, this.bearer).subscribe(
      (res) => {
        console.log({ res });

        let productData = this.getProductData(productId);
        productData.display_status = res['data']?.display ? '9' : '1';
        this.removeUpdateDisplayQueue(productId);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getProductData(productId: number) {
    return this.displayedProducts.find(
      (product) => +product.p_id === +productId
    );
  }

  getEditProductLink(productId: number, country_code: string) {
    const { language_code } = this; 
    return `/dashboard/product/edit/${language_code.toLowerCase()}/${country_code.toLowerCase()}/${productId}`;
  }

  getFlagByCountryCode(country_code: string) {
    country_code = (country_code || '').toLowerCase().substr(-2, 2);
    country_code = country_code === 'cm' ? 'kh' : country_code;
    return country_code;
  }

  getFlagImageURL(country_code: string) {
    country_code = this.getFlagByCountryCode(country_code);
    return `https://cdn.estore5s.com/asset/flags/${country_code}.png`;
  }

  getCountryName(country_code: string) {
    if (country_code === '' || !country_code) {
      return 'All Countries';
    }
    country_code = (country_code || '').toLowerCase();
    const country = this.country?.find(
      (c) => (c.country_code || '').toLowerCase() === country_code
    );

    return country?.country_name ?? country_code;
  }

  getSubscription(subscription: string) {
    if (this.is_subscription === 0) {
      subscription = 'Products';
    } else if (this.is_subscription === 1) {
      subscription = 'Subscriptions';
    }
    return subscription;
  }

  filterProducts(products: any, filterString: any) {
    if (!products || products.length === 0) {
      return products;
    }

    this.subscriptionProduct = products.some(
      (obj) => obj.country_code === filterString[1] && obj.is_subscription == 1
    );

    return products.filter((product: any) => {
      // Filter by search query
      const keywordsFilter = filterString[0].toLowerCase().split(' ');
      const keywordsFilterResult = keywordsFilter.every(
        (keyword) => product.product_name.toLowerCase().indexOf(keyword) >= 0
      );

      // Filter by country
      const countryFilter = filterString[1];
      const countryFilterResult =
        countryFilter === '' || product['country_code'] === countryFilter;

      // Filter by status
      const statusFilter = filterString[2];
      const statusFilterResult =
        statusFilter === '' || product['display_status'] === statusFilter;

      // Filter by subscription
      const subscriptionFilter = this.is_subscription;
      const subscriptionFilterResult =
        product['is_subscription'] === subscriptionFilter;

      return (
        keywordsFilterResult &&
        countryFilterResult &&
        statusFilterResult &&
        subscriptionFilterResult
      );
    });
  }

  clearProductSearch() {
    this.filteredString = '';
    this.updateFilter({ target: { value: '' } });
  }

  updateFilter(event = null) {
    const filteredProducts = this.filterProducts(this.products, [
      this.filteredString,
      this.filteredCountry,
      this.filteredStatus,
    ]);
    this.displayedProducts = filteredProducts;
    this.dataService.updateProductFilters({
      filteredString: this.filteredString,
      filteredCountry: this.filteredCountry,
      is_subscription: this.is_subscription,
      subscription: this.subscription
    });
  }

  getDisplayedProducts() {
    console.log('this.displayedProducts', this.displayedProducts);
    return this.displayedProducts;
  }

  selectPage(page: any) {
    this.selectedPage = page;
    this.page = 1;
  }

  changePage(pageOfItems) {
    this.page = pageOfItems;
    this.updateFilter();
  }

  openModalContent(image) {
    this.modalService
      .open(image, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'lg',
        windowClass: 'modal-customer',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  changeListingView(viewType: ListingViewMode) {
    this.listingView = viewType;
  }

  /*
  Drag & Drop logic
  */
  ngAfterViewInit() {
    let phElement = this.placeholder?.element?.nativeElement;
    phElement.style.display = 'none';
    phElement.parentElement.removeChild(phElement);
  }

  dragMoved(e: CdkDragMove) {
    let point = this.getPointerPositionOnPage(e.event);

    this.listGroup._items.forEach((dropList) => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        let sourceId = e.source.dropContainer.id;
        let targetId = dropList.id;

        // console.log('dropList', dropList);
        this.activeContainer = dropList;
        // dropList.element.nativeElement.style.backgroundColor = '#7744ff7a';
        let childrenList =
          e.source.dropContainer.element.nativeElement.parentElement.children;
        let sourceEl: any = e.source.dropContainer.element.nativeElement;
        let targetEl: any = e.source.dropContainer.element.nativeElement;

        let sourceIndex = -1;
        let targetIndex = -1;

        [...(childrenList as any)].forEach((child, index) => {
          if (child.id === sourceId) sourceIndex = index;
          if (child.id === targetId) targetIndex = index;
        });

        if (targetIndex !== sourceIndex) {
          // console.log({ sourceIndex, targetIndex });
          // console.log({ sourceId, targetId });

          if (this.filteredString === '') {
            console.log('Moving', sourceIndex, targetIndex);
            moveItemInArray(this.displayedProducts, sourceIndex, targetIndex);
          }
        }
        return;
      }
    });
  }

  dragDropped(e: CdkDragMove) {
    console.log('dragDropped', e);

    if (this.filteredString === '') {
      // Do drop logic
      this.generateArrangementList();
    } else {
      console.log('Clear filter before changing Custom Arrangement');
    }
  }

  dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    // drag.element.nativeElement.style.backgroundColor = 'blue';

    if (drop == this.placeholder) return true;
    if (drop != this.activeContainer) return false;

    /*
    let phElement = this.placeholder?.element?.nativeElement;
    let sourceElement = drag.dropContainer.element.nativeElement;
    let dropElement = drop.element.nativeElement;

    let dragIndex = __indexOf(
      dropElement.parentElement.children,
      this.source ? phElement : sourceElement
    );
    let dropIndex = __indexOf(dropElement.parentElement.children, dropElement);
    console.log('dragIndex', dragIndex, dropIndex);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(
      phElement,
      dropIndex > dragIndex ? dropElement.nextSibling : dropElement
    );

    console.log('this.placeholder._dropListRef', this.placeholder._dropListRef);
    console.log('drag._dragRef', drag._dragRef);
    console.log('drag._dragRef', drag.element);

    // this.placeholder._dropListRef.enter(
    //   drag._dragRef,
    //   drag.element.nativeElement.offsetLeft,
    //   drag.element.nativeElement.offsetTop
    // );

    */
    return false;
  };

  /** Determines the point of the page that was touched by the user. */
  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
    const point = __isTouchEvent(event)
      ? event.touches[0] || event.changedTouches[0]
      : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top,
    };
  }
}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(
  dropList: CdkDropList,
  x: number,
  y: number
) {
  const { top, bottom, left, right } =
    dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}
